import styled from 'styled-components';

export const Section = styled.section`
    padding: 40px 0px;
`